import React from 'react'
import { Modal } from 'react-bootstrap'



export default class FormInput extends React.Component {
    render() {
        const { changeHandler, saveHandler, Model, showModal, cancelHandler, showModalSave, Mode, showModalDel, showModalDelete, cancelHandlerDel, saveHandlerDel, handleValidation, errors } = this.props
        return (
            <div class="mb-10" class="container-lg">

                <Modal show={showModal} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="mb-3">

                            <label for="name" class="form-label">Name*</label>
                            <input type="text" class="form-control" id="name" value={Model.name} onChange={changeHandler("name")} />
                            <span className="error">{errors["name"]}</span>
                        </div>

                        <p style={{ fontStyle: "italic" }}>*Wajib Diisi</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <div>
                            <button type="button" class="btn btn-danger" onClick={cancelHandler}>Batal</button>
                            <button type="button" class="btn btn-outline-primary ml-2" onClick={saveHandler}>Simpan</button>
                        </div>
                    </Modal.Footer>
                </Modal>


                <Modal show={showModalDel} onHide={cancelHandlerDel}>
                    <Modal.Header closeButton>
                        <Modal.Title>Hapus</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="mb-3 text-center">
                            <p>Anda akan menghapus {Model.name}</p>
                            <p>Yakin hapus?</p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <div>
                            <button type="button" class="btn btn-danger" onClick={cancelHandlerDel}>No</button>
                            <button type="button" class="btn btn-outline-primary ml-2" onClick={saveHandlerDel}>Yes</button>
                        </div>
                    </Modal.Footer>
                </Modal>



                <Modal show={showModalSave} onHide={cancelHandlerDel}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="mb-3">
                            <p>Berhasil {Mode}</p>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={showModalDelete} onHide={cancelHandlerDel}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="mb-3">
                            <p>Berhasil</p>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>

        )
    }

}